module.exports = __webpack_public_path__ + "static/img/1-1.213f9d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/1-1.png
// module id = y7PF
// module chunks = 0